module.exports = __webpack_public_path__ + "static/media/news-cdphp-sandwich-generation.1fa9bdba.jpg";